import Spinner from 'shopper/components/Spinner';

const Loading = () => (
  <div className="flex h-[60vh] items-center justify-center">
    <Spinner />
  </div>
);

export default Loading;
